<script setup>
import { computed, ref } from "vue";
import { useMainStore } from "@/stores/main.js";
import { PERIODS, CUSTOM_PERIOD } from "@/periods";
import { formatDateRange } from "@/utils";
import MSheet from "@/components/m/MSheet.vue";
import MIcon from "@/components/m/MIcon.vue";

/* Mobile date-period + aggregation control. Mirrors the desktop BtFilters so
   the native shell isn't silently pinned to a default period. Custom ranges
   stay desktop-only for now (the calendar picker isn't ported); the preset
   periods cover the common cases. */
const mainStore = useMainStore();
const AGGREGATIONS = ["Monthly", "Weekly"];
const PRESETS = PERIODS.filter((p) => p !== CUSTOM_PERIOD);

const open = ref(false);

const label = computed(() =>
  mainStore.selectedPeriod === CUSTOM_PERIOD
    ? formatDateRange(mainStore.customStart, mainStore.customEnd)
    : mainStore.selectedPeriod,
);

const pickPeriod = (period) => {
  mainStore.setSelectedPeriod(period);
  open.value = false;
};
const pickAgg = (agg) => mainStore.setAggregation(agg);
</script>

<template>
  <div class="btm-pad" style="padding-bottom: 10px">
    <button
      type="button"
      class="btm-chip"
      style="height: 38px; gap: 7px"
      aria-label="Change time period"
      @click="open = true"
    >
      <MIcon name="clock" :size="14" />{{ label }}
      <MIcon name="chevdown" :size="12" :sw="2.4" style="opacity: 0.6" />
    </button>

    <MSheet :open="open" label="Time period" @close="open = false">
      <div style="font-weight: 800; font-size: 16px; margin-bottom: 12px">
        Time period
      </div>

      <div class="btm-seg" style="margin-bottom: 16px">
        <button
          v-for="agg in AGGREGATIONS"
          :key="agg"
          type="button"
          :class="{ on: mainStore.selectedAggregation === agg }"
          @click="pickAgg(agg)"
        >
          {{ agg }}
        </button>
      </div>

      <button
        v-for="period in PRESETS"
        :key="period"
        type="button"
        class="btm-trow"
        style="
          width: 100%;
          justify-content: space-between;
          background: none;
          border: 0;
          border-top: 1px solid var(--border);
          font-family: inherit;
          font-size: 14px;
          color: var(--text);
          cursor: pointer;
        "
        @click="pickPeriod(period)"
      >
        <span>{{ period }}</span>
        <MIcon
          v-if="mainStore.selectedPeriod === period"
          name="check"
          :size="18"
        />
      </button>
    </MSheet>
  </div>
</template>
